export const CURRENT = 9;

export type BookYear = {
  id?: number;
  start_year: number;
  visual: string;
  short_visual: string;
}